// extracted by mini-css-extract-plugin
export default {"toggleBtn":"PointAndEventPanel_toggleBtn__FEnlG","multiSwitchWrapper":"PointAndEventPanel_multiSwitchWrapper__kXFnv"};